import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { RiContactsBookUploadFill } from "react-icons/ri";
import Loader from "../../commonComponent/Loader";
import {
  getMyAssignedPatientList,
  getMyPatientList,
  getPatientList,
} from "../../services/PatientService";
import { groupMembers } from "../../Utils/AllConstant";
import ApiConfig from "../../config/ApiConfig";
import {
  getActiveMembers,
  getActiveProgramById,
  inviteMembers,
  updateActiveProgramById,
} from "../../services/ActivePrograms";
import {
  filterSoftDeletedClient,
  showToastError,
  showToastSuccess,
  sortByName,
  validateEmail,
} from "../../Utils/Helper";
import { AiOutlineCloseCircle, AiOutlinePlus } from "react-icons/ai";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import { useHover } from "../../customHook/useHover";
import { useAuth } from "../../Context/AuthContext";

const ActiveMemberModal = ({
  state,
  selectedMembers,
  members,
  open,
  setOpen,
  addMember,
  setMembers,
  programId,
}) => {
  const [check, setCheck] = useState(0);
  const [patientLists, setPatientLists] = useState([]);
  const [filterdata, setFilterData] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const [memberList, setMemberList] = useState([]);
  const [program, setProgram] = useState({});
  const [formValues, setFormValues] = useState([
    { email: "", first_name: "", last_name: "" },
  ]);
  const [ProgramDetails, setProgramDetails] = useState({});
  const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();
  const { isAdmin } = useAuth();

  useEffect(() => {
    getProgram();
  }, [programId]);

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      { email: "", first_name: "", last_name: "" },
    ]);
  };

  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(programId);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  let handleChange = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
  };

  let handleSubmit = async (event) => {
    event.preventDefault();
    var parms = {};
    parms["EmailList"] = formValues;

    try {
      const response = await inviteMembers(parms);
      //   setAskLoader(false)
      if (response.status === 200) {
        updateProgram(response?.data?.data);
        showToastSuccess("Invite sent successfully");
        setFormValues([{ email: "", first_name: "", last_name: "" }]);
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      //   setAskLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  let handleMember = async () => {
    var parms = {};
    parms["EmailList"] = selectedMembers.map((dt) => {
      return { name: dt.name, email: dt.email };
    });

    try {
      const response = await inviteMembers(parms);
      // setAskLoader(false)
      if (response.status === 200) {
        updateProgram(response?.data?.data);
        showToastSuccess("Invite sent successfully");
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      // setAskLoader(false)
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const getMembersById = async (searchWord) => {
    try {
      const response = await getActiveMembers(programId, searchWord);
      // setLoader(false);
      if (response.status === 200) {
        setMemberList(response?.data?.data[0]?.programMembers);
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      // setLoader(false);
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
    }
  };
  // const [memebertLists, setMemberLists] = useState([]);
  // Server Methods
  const updateProgram = async (programMembers) => {
    setLoader(true);
    try {
      // const fileName = program.programImage.split('/')
      // const imageName = fileName[fileName.length - 1];
      const response = await updateActiveProgramById(programId, {
        ...ProgramDetails,
        // programImage: imageName,
        programMembers: programMembers,
      });
      if (response) {
        showToastSuccess("Members Assigned Successfully");
        getMembersById();
        getProgram();
        // props.onRefresh()
        // setProgramMembers([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  // const getPatientLists = async (searchWord) => {
  //   setPatientLists([]);
  //   setMembers([]);

  //   try {
  //     const response = await getMyPatientList(searchWord);
  //     setLoader(false);
  //     if (response.status === 200) {
  //       let sortedData = sortByName(filterSoftDeletedClient(response?.data?.data))
  //       setPatientLists(sortedData);
  //       setFilterData(sortedData);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.log(error);
  //   }
  // };

  const getPatientLists = async () => {
    setLoader(true);
    setPatientLists([]);
    setMembers([]);
    try {
      let assignedPatientResponse;
      let allPatientResponse;

      // Assuming isAdmin is a boolean indicating whether the user is an admin
      if (!isAdmin) {
        assignedPatientResponse = await getMyAssignedPatientList();
      }
      allPatientResponse = await getPatientList();

      setLoader(false);

      if (allPatientResponse.status === 200) {
        const assignedPatientData = assignedPatientResponse?.data?.data || [];
        const allPatientData = allPatientResponse?.data?.data || [];
        const combinedData = [...allPatientData];

        if (assignedPatientData.length > 0) {
          combinedData.push(...assignedPatientData);
        }
        let sortedData = sortByName(filterSoftDeletedClient(combinedData));
        setPatientLists(sortedData);
        setFilterData(sortedData);

        // Additional logic here if needed
        // props.onselectpatient(sortedData[sortedData.length - 1]);
        // dispatch(setPatientList(sortedData.reverse()));
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const UpdateMember = (checked, members) => {
    let member = JSON.parse(members);
    if (checked) {
      setCheck((prev) => prev + 1);
      setMembers((prev) => [...prev, member]);
    } else {
      setCheck((prev) => prev - 1);
      setMembers((prev) => prev.filter((dt) => dt._id != member._id));
    }
  };
  const onSearch = async (e) => {
    let searchWord = e.target.value;
    const result = patientLists.filter((value) => {
      if (value) {
        // console.log(value, "value")
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });

    if (searchWord === "") {
      setFilterData(patientLists);
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
    }
  };

  const getActiveProgramByIds = async () => {
    setLoader(true);
    // console.log(sessionId);
    try {
      const response = await getActiveProgramById(ProgramDetails._id);

      if (response.status === 200 && response?.data) {
        // console.log(response, "program resp")
        setProgram(response?.data?.data);
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };
  useEffect(() => {
    getPatientLists();
    // console.log(patientLists, "patientLists")
  }, []);

  useEffect(() => {
    if (!open) setFilterData([]);
    else {
      setMembers([]);
      setFilterData(patientLists);
    }
  }, [open]);

  return (
    <>
      <div
        class="modal fade"
        id="memberModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="memberModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header p-4">
              {/* <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> */}
              <h5 className="mb-0">Add new members</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-4 px-4">
              <h4 className="text-green mb-2">{ProgramDetails?.programName}</h4>
              <p className="mb-5">{ProgramDetails?.description}</p>
              <form onSubmit={handleSubmit}>
                <div className="mb-1">
                  <div className="row mb-2">
                    <div className="col-md-5">
                      <label className="form-label" for="email">
                        Email Address<span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">
                        Name<span> (Optional)</span>
                      </label>
                    </div>
                  </div>
                  {formValues.map((element, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-5">
                        {/* <label className="form-label">Email Address</label> */}
                        <input
                          className="form-control description_inputf mb-2"
                          type="email"
                          id="email"
                          name="email"
                          placeholder="e.g. sharonjames@gmail.com"
                          value={element.email || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                        {element.email !== "" &&
                        !validateEmail(element.email) ? (
                          <label className="text-danger m-1">
                            Email format is not valid.
                          </label>
                        ) : null}
                      </div>
                      <div className="col-md-5">
                        {/* <label className="form-label">Name</label> */}
                        <input
                          className="form-control description_inputf mb-2"
                          type="text"
                          name="first_name"
                          placeholder="e.g. Sharon James"
                          value={element.first_name || ""}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </div>

                      <div className="col-md-2 d-flex align-items-center">
                        {index ? (
                          <button
                            type="button"
                            title="Remove"
                            className="btn btn-outline-danger px-2"
                            onClick={() => removeFormFields(index)}
                          >
                            <AiOutlineCloseCircle
                              style={{ marginTop: "-4px" }}
                              size="22px"
                            />
                          </button>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  className="btn-custom-link ms-0 mt-3 mb-5"
                  onClick={() => addFormFields()}
                >
                  <AiOutlinePlus className="me-2" /> Add new
                </div>
                <hr className="mt-4 px-3" />
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-outline-secondary px-4"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    disabled={
                      formValues.filter((dt) => !validateEmail(dt.email))
                        .length > 0
                    }
                    className="btn btn-primary btn-custom"
                    type="submit"
                    data-bs-dismiss="modal"
                  >
                    Send Invitation
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="addmembermodal1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content px-4">
            <div className="modal-header px-4 border-0 mt-3">
              <h5 className="modal-title">Add members</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setOpen(false)}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-4 pb-2 px-4">
              <div
                style={{
                  marginTop: "-10px",
                  display: "flex",
                  justifyContent: "end",
                  marginBottom: "20px",
                  marginLeft: "-5px",
                }}
              >
                <div className="actsearch_box1">
                  <FiSearch className="boxicon" />
                  <input
                    placeholder="Search Here..."
                    onChange={(e) => onSearch(e)}
                  />
                </div>
              </div>

              <div className="col-md-12 p-1">
                <div
                  className="memlist_scroll mt-1 justify-content-center spacing_scroll"
                  style={{ height: 300 }}
                >
                  {isLoading ? (
                    <center>
                      <Loader
                        visible={isLoading}
                        style={{ top: "48px", position: "relative" }}
                      />
                    </center>
                  ) : filterdata?.length ? (
                    filterdata
                      .filter((dt) => !members?.includes(dt._id))
                      .map((dt, index) => {
                        return (
                          <div
                            key={dt._id}
                            // className={`card mb-2 p-1 ${index == 0 ? "active" : ""}`}
                            className={`card mb-2 py-2 px-3`}
                            style={{ background: "#F2F4F6" }}
                            onClick={() => {}}
                            id={dt._id}
                          >
                            <div className="btn-group align-items-center gap-2">
                              <p className="affir_checkbox mb-0">
                                <input
                                  type="checkbox"
                                  name="members"
                                  value={JSON.stringify({
                                    _id: dt._id,
                                    name: dt.full_name,
                                    email: dt.email,
                                  })}
                                  id="flexCheckDefault"
                                  onChange={(e) =>
                                    UpdateMember(
                                      e.target.checked,
                                      e.target.value
                                    )
                                  }
                                />
                              </p>

                              <div
                                className="p-0 actlist_wid1 d-flex mb-0 justify-content-center align-items-center affir_checkbox avatar_warper"
                                htmlFor="flexCheckDefault"
                                onMouseEnter={() => handleMouseEnter(dt._id)}
                                onMouseLeave={handleMouseLeave}
                              >
                                <img
                                  src={
                                    dt.profilePicture
                                      ? ApiConfig.ImageUrl +
                                        "user/" +
                                        dt._id +
                                        "/" +
                                        dt.profilePicture
                                      : "images/avatar.png"
                                  }
                                  onError={(e) => {
                                    e.target.src = "images/avatar.png"; //replacement image imported above
                                  }}
                                  alt=""
                                  className="member_listimage"
                                />
                                <AvatarPopover
                                  data={dt}
                                  onHover={dt._id === hoveredUserId}
                                />
                              </div>
                              <div className="actlist_wid2 ms-2">
                                <p className="py-0 mb-0">
                                  {dt?.full_name?.trim("")
                                    ? dt?.full_name !== "undefined undefined"
                                      ? dt?.full_name
                                      : "Anonymous"
                                    : "Anonymous"}
                                </p>
                              </div>
                            </div>
                            <div className="table_resouter card bg-light p-2 my-2">
                              <table class="table mb-0 table-borderless table_resinner4">
                                <tbody>
                                  <tr>
                                    <td>
                                      <span className="fw-bold">
                                        Employment Status:
                                      </span>{" "}
                                      {dt.employmentStatus
                                        ? dt.employmentStatus
                                        : "Unknown"}
                                    </td>
                                    <td>
                                      <span className="fw-bold">Status:</span>{" "}
                                      {dt.status ? (
                                        <span className="text-success">
                                          ◉ Active
                                        </span>
                                      ) : (
                                        <span className="text-danger">
                                          ◉ In Active
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-lowercase">
                                      <span className="fw-bold text-capitalize">
                                        Email:
                                      </span>{" "}
                                      {dt.email}
                                    </td>
                                    <td>
                                      <span className="fw-bold">Location:</span>{" "}
                                      {dt.city ? dt.city : "Unknown"}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <p className="p-2">No data found!</p>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer px-3 border-0 mb-3">
              <button
                onClick={() => {
                  addMember();
                  setOpen(false);
                }}
                data-bs-dismiss="modal"
                disabled={check == 0}
                className="description_btnsave w-100"
                style={{
                  backgroundColor: "#1f7e78",
                  borderColor: "#1f7e78",
                }}
              >
                {"Add"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveMemberModal;
